module.exports = __webpack_public_path__ + "img/1024.1762256b.svg";